module.exports = __webpack_public_path__ + "img/akkodis-option.60bde030.webp";